import React from 'react';
import Close from '../../../assets/close.png';
import styles from '../../../styles/LandingPagev1/common.module.css';

export default function EnquiryDrawer(props) {
    const { options, setEnquiryOpen, enquiryOpen, onOptionSelect } = props;

    return (
        <React.Fragment>
            <div className={styles.mobileDrawerOverlay} />
            <div className={styles.mobileDrawer} role="dialog" aria-modal="true">
                <div className={styles.mobileDrawerHeader}>
                    <div className={styles.mobileDrawerTitle}>Select an option</div>
                    <img
                        src={Close}
                        onClick={() => { setEnquiryOpen(false) }}
                        alt="Close" className={styles.mobileDrawerClose}
                    />
                </div>
                <div className={styles.mobileDrawerList}>
                    {options.map((option, idx) => (
                        <div
                            key={idx}
                            className={`${styles.dropdownItem} ${idx === 0 ? styles.dropdownItemActive : ''}`}
                            onClick={() => {
                                onOptionSelect(idx, option)
                            }}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    )
}
